// 接口文档：https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=45861836#id-%E6%B5%81%E6%9C%8D%E5%8A%A1%E6%8E%A5%E5%8F%A3-%E7%94%A8%E6%88%B7%E8%A7%A6%E5%8F%91%E9%82%AE%E4%BB%B6%E9%80%80%E8%AE%A2
export const HOST = ['https://test-ms.ihuhoo.com', 'https://ms-public.tradeup.com'];

export const API = {
    unsubscribe: '/stream/public/unsubscribe/mail'
};
